import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export function useCreateInitialUserMutation({
	onError,
	onSuccess,
}: {
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: (value: Api.IUser) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			account,
			email,
			firstName,
			lastName,
			phone,
		}: {
			account: Api.IAccount;
			email: string;
			firstName: string;
			lastName: string;
			phone?: string;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IUser>('user/initiate-create?sendWelcomeEmail=false', 'POST', {
				accountId: account.id,
				email,
				firstName,
				lastName,
				mobilePhone: phone,
				token: account.initialUserToken,
			});
		},
		onError,
		onSuccess,
	});
}
